const useFormattedDate = (predate) => {
  const date = new Date(predate);

  // Используем toLocaleDateString для форматирования даты
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  const formatted = date.toLocaleDateString("ru-RU", options); // Форматируем дату в формате ДД.ММ.ГГГГ

  return formatted;
};

export default useFormattedDate